import { Brand } from '@aura/contextos-frontend/dist/contexts/config/config.types';

const URL_CHAT_HELP = 'https://yduqs2020.my.salesforce-sites.com/atlchat?marca=[MARCA]&origem=sava';

const getCapitalizeString = (str: string): string => {
  return `${str.charAt(0).toUpperCase()}${str.substring(1)}`;
};

export const getLinkChatHelpByMarca = (marca: Brand): string =>
  URL_CHAT_HELP.replace('[MARCA]', getCapitalizeString(marca));
